import React, { createContext, useContext, useState, useCallback } from 'react';

const EditorV2Context = createContext(null);

export function EditorV2Provider({ children }) {
  const [activeVSCode, setActiveVSCode] = useState(null);
  const [isDeploying, setIsDeploying] = useState(false);
  const [isScheduleModalShown, setIsScheduleModalShown] = useState(false);
  const [isPullRequestModalV2Shown, setIsPullRequestModalV2Shown] = useState(false);
  const [sandboxRefreshTrigger, setSandboxRefreshTrigger] = useState(0);

  const triggerSandboxRefresh = useCallback(() => {
    setSandboxRefreshTrigger(prev => prev + 1);
  }, []);

  return (
    <EditorV2Context.Provider value={{
      activeVSCode, setActiveVSCode,
      isDeploying, setIsDeploying,
      isScheduleModalShown, setIsScheduleModalShown,
      isPullRequestModalV2Shown, setIsPullRequestModalV2Shown,
      sandboxRefreshTrigger, triggerSandboxRefresh
    }}>
      {children}
    </EditorV2Context.Provider>
  );
}

export const useEditorV2 = () => useContext(EditorV2Context);
